// src/components/small-format/PaperSizeSelector.js
import React from 'react';

const PaperSizeSelector = ({
  paperSizes,
  selectedSize,
  onChange,
  width,
  height,
  onWidthChange,
  onHeightChange
}) => {
  // Group paper sizes (existing code)
  const groupedSizes = {};
  Object.entries(paperSizes).forEach(([sizeName, dimensions]) => {
    const category = sizeName.charAt(0).toUpperCase();
    if (!groupedSizes[category]) {
      groupedSizes[category] = [];
    }
    groupedSizes[category].push({ name: sizeName, ...dimensions });
  });
  const commonSizes = ['A4', 'A5', 'A6', 'DL'];

  // Handle size change (existing code)
  const handleSizeChange = (e) => {
    const sizeName = e.target.value;
    onChange(sizeName);
  };

  // Toggle orientation (existing code)
  const toggleOrientation = () => {
    onWidthChange(height);
    onHeightChange(width);
  };

  // Helper function to determine orientation text (existing code)
  const getOrientationText = () => {
    if (!width || !height || width <= 0 || height <= 0) {
      return '-'; // Indicate indeterminate state
    }
    return width > height ? 'Landscape' : 'Portrait';
  };

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        {/* Standard size selector */}
        <div>
          <select
            value={selectedSize}
            onChange={handleSizeChange}
            className="w-full p-2 border rounded"
          >
            <option value="">Custom size</option>
            {/* Common sizes first */}
            <optgroup label="Common Sizes">
              {commonSizes.map(size => {
                if (paperSizes[size]) {
                  return (
                    <option key={size} value={size}>
                      {size} ({paperSizes[size].width_mm}×{paperSizes[size].height_mm}mm)
                    </option>
                  );
                }
                return null;
              })}
            </optgroup>
            {/* Group other sizes by category */}
            {Object.keys(groupedSizes).sort().map(category => (
              <optgroup key={category} label={`${category} Sizes`}>
                {groupedSizes[category]
                  .filter(size => !commonSizes.includes(size.name))
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(size => (
                    <option key={size.name} value={size.name}>
                      {size.name} ({size.width_mm}×{size.height_mm}mm)
                    </option>
                  ))
                }
              </optgroup>
            ))}
          </select>
        </div>

        {/* Orientation toggle Button */}
        {/* Removed the wrapper div and space-x-3 as the indicator is gone */}
        <div className="flex items-center">
          <button
            type="button"
            onClick={toggleOrientation}
            // Adjusted padding/width for better look with dynamic text
            className="flex items-center justify-center px-3 py-2 border rounded hover:bg-gray-100 w-full sm:w-auto"
            title="Switch orientation" // Keep the title for tooltip
          >
            {/* Keep the icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
              />
            </svg>
            {/* --- START: Modified Button Text --- */}
            {/* Display the orientation text directly on the button */}
            <span className="ml-2 font-medium text-sm whitespace-nowrap">
               {getOrientationText()}
            </span>
            {/* --- END: Modified Button Text --- */}
          </button>

          {/* --- REMOVED the separate indicator span --- */}
        </div>
      </div>

      {/* Custom dimensions */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">Width (mm)</label>
          <input
            type="number"
            value={width || ''}
            onChange={(e) => onWidthChange(Number(e.target.value) || 0)}
            className="w-full p-2 border rounded"
            min="1"
            placeholder="Width"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Height (mm)</label>
          <input
            type="number"
            value={height || ''}
            onChange={(e) => onHeightChange(Number(e.target.value) || 0)}
            className="w-full p-2 border rounded"
            min="1"
            placeholder="Height"
          />
        </div>
      </div>
    </div>
  );
};

export default PaperSizeSelector;
